import React, { useContext } from 'react';
import styled from 'styled-components';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'shared/components/Select'. 'app/webpack/javascripts/shared/components/Select.js' implicitly has an 'any' type.
import Select from 'shared/components/Select';
import { withLocalePrefix } from 'shared/utils/translation';
import { ContentDescription, Loading, Required } from '../../components';
import { MultipleRulesContext } from '../../multiple_rules/context';
import { DataRetentionRulesContext } from '../context';
import ManualEmailEntry from './manual_emal_entry';

type Props = {
  emails: Array<string>;
  onChangeEmails: any;
  onChangeSelectedUsers: any;
  selectedUsers: Array<{
    label: string;
    value: number;
  }>;
};

const t = withLocalePrefix('gdpr.data_retention_rules.view.edit.notifications');

export default function NotificationRecipients(props: Props) {
  const { emails, selectedUsers, onChangeEmails, onChangeSelectedUsers } =
    props;

  const { displayManualEmailEntry } = useContext(MultipleRulesContext);
  const { notificationOptions, onGetNotificationData } = useContext(
    DataRetentionRulesContext
  );
  if (notificationOptions.length === 0) {
    onGetNotificationData();
  }
  return (
    <div id="user-section">
      <ContentDescription>
        {t('select')} <Required />
      </ContentDescription>
      {(notificationOptions.length === 0 && <Loading />) || (
        <StyledSelect
          multi
          placeholder={t('select_placeholder')}
          options={notificationOptions}
          value={selectedUsers}
          onChange={onChangeSelectedUsers}
        />
      )}
      {displayManualEmailEntry && (
        <ManualEmailEntry emails={emails} onChangeEmails={onChangeEmails} />
      )}
    </div>
  );
}

const ClickableSpan = styled.span`
  cursor: pointer;
  display: inline-block;
  height: 33px;
  padding-left: 10px;
  position: relative;
  top: 5px;
  vertical-align: middle;
`;
ClickableSpan.displayName = 'ClickableSpan';

export const StyledSelect = styled(Select)`
  display: inline-block;
  width: 455px;
`;
